module.exports = __webpack_public_path__ + "static/img/404.78522d18.png";